import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/app/app-routes';
import {
	RequestConsentTaxFolder,
	ResponseConsentTaxFolder,
} from 'src/app/interfaces/consent-tax-folder.interface';
import {
	RequestValidateCustomerData,
	ResponseValidateCustomerData,
} from 'src/app/interfaces/customer-data.interface';
import {
	RequestGenerateSendOtp,
	ResponseGenerateSendOtp,
} from 'src/app/interfaces/generate-send-otp.interface';
import { ResponseInitialParameters } from 'src/app/interfaces/initial-parameters.interface';
import {
	RequestOtpValidation,
	ResponseOtpValidation,
} from 'src/app/interfaces/otp-validation.interface';
import { PurposesRequest, PurposesResponse } from 'src/app/interfaces/get-purposes';
import { RegisterPurposesRequest } from 'src/app/interfaces/register-purposes';
import { RequestTaxFolder, ResponseTaxFolder } from 'src/app/interfaces/tax-folder.interface';
import { SKIP_LOADER } from 'src/app/utils/constants';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	private publicSimulatorExp = ApiEndpoints.publicSimulatorExp;
	private policiesAndConsentsBff = ApiEndpoints.policiesAndConsentsBff;

	constructor(private readonly http: HttpClient) {}

	initialParameters(product: string): Observable<ResponseInitialParameters> {
		return this.http.get<ResponseInitialParameters>(
			`${this.publicSimulatorExp.initialParameters}/${product}/parametros`
		);
	}

	validateCustomerData(
		request: RequestValidateCustomerData
	): Observable<ResponseValidateCustomerData> {
		return this.http.post<ResponseValidateCustomerData>(
			`${this.publicSimulatorExp.validate}`,
			request
		);
	}

	consentTaxFolder(request: RequestConsentTaxFolder): Observable<ResponseConsentTaxFolder> {
		return this.http.post<ResponseConsentTaxFolder>(`${this.publicSimulatorExp.consent}`, request);
	}

	taxFolder(request: RequestTaxFolder): Observable<ResponseTaxFolder> {
		return this.http.post<ResponseTaxFolder>(`${this.publicSimulatorExp.requestTaxFolder}`, request);
	}

	generateAndSendOtp(
		request: RequestGenerateSendOtp,
		skipLoader: boolean
	): Observable<ResponseGenerateSendOtp> {
		return this.http.post<ResponseGenerateSendOtp>(
			`${this.publicSimulatorExp.generateSendOtp}`,
			request,
			{ context: new HttpContext().set(SKIP_LOADER, skipLoader) }
		);
	}

	validateOtp(request: RequestOtpValidation): Observable<ResponseOtpValidation> {
		return this.http.post<ResponseOtpValidation>(`${this.publicSimulatorExp.otpValidation}`, request);
	}

	purposes(request: PurposesRequest): Observable<PurposesResponse> {
		return this.http.post<PurposesResponse>(
			`${this.policiesAndConsentsBff.getPublicPurposes}`,
			request
		);
	}

	registerPurposes(request: RegisterPurposesRequest): Observable<void> {
		return this.http.post<void>(`${this.policiesAndConsentsBff.setPublicConsents}`, request);
	}
}
